import {Component, OnInit} from '@angular/core';
import {OrderType} from '../services/order-type';
import {OrderTypesService} from '../services/order-types.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {OrderTypeEditModalComponent} from '../order-type-edit-modal/order-type-edit-modal.component';
import {SortableOptions} from "sortablejs";

@Component({
    selector: 'app-order-types',
    templateUrl: './order-types.component.html',
    styleUrls: ['./order-types.component.sass'],
    providers: [OrderTypesService]
})
export class OrderTypesComponent implements OnInit {

    options: SortableOptions = {
        handle: '.sortablejs--handle',
        onUpdate: (_) => {
            this.saveSorting();
        }
    };

    orderTypes: OrderType[];

    loading = false;
    saving = false;

    constructor(public orderTypesService: OrderTypesService,
                public ngbModal: NgbModal) {
    }

    ngOnInit(): void {
        this.load();
    }

    load() {
        this.loading = true;

        this.orderTypesService.getOrderTypes().subscribe(response => {
            this.orderTypes = response.data;

            this.loading = false;
        });
    }

    add() {
        const self = this;

        const modalRef = this.ngbModal.open(OrderTypeEditModalComponent, {size: 'lg'});
        modalRef.componentInstance.saved = () => {
            self.load();
        };
    }

    edit(orderType: OrderType) {
        const self = this;

        const modalRef = this.ngbModal.open(OrderTypeEditModalComponent, {size: 'lg'});
        modalRef.componentInstance.orderType = orderType;
        modalRef.componentInstance.saved = () => {
            self.load();
        };
    }

    delete(orderType: OrderType) {
        if (confirm($localize `Are you sure?\n\nThe order Type will be deleted`)) {
            this.loading = true;

            this.orderTypesService.deleteOrderType(orderType).subscribe(_ => {
                this.loading = false;

                this.load();
            });
        }
    }

    saveSorting() {
        this.saving = true;
        this.options = {
            ...this.options,
            disabled: true
        };

        let sorting = 0;
        const orderTypes = [];

        for (const orderType of this.orderTypes) {
            orderTypes.push(OrderType.fromJSON({
                id: orderType.id,
                sorting
            }));

            sorting++;
        }

        this.orderTypesService.updateOrderTypes(orderTypes).subscribe(_ => {
            this.saving = false;
            this.options = {
                ...this.options,
                disabled: false
            };
        });
    }
}
